var React = require('react');

function ArrowDownInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7 11.583V0h2v11.589l4.336-4.337 1.415 1.415-6.04 6.04a1 1 0 0 1-1.415 0l-6.04-6.04L2.67 7.252 7 11.582z","fill":"currentColor"}));
}

ArrowDownInline.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = ArrowDownInline;

ArrowDownInline.default = ArrowDownInline;
